import { gql } from "../../../../../gql/__generated__/gql";

export const GET_MESSAGES_FOR_COLLAB = gql(`
  query getMessagesForCollab($collabId: String!) {
    getMessagesForCollab(collabId: $collabId) {
      collabId
      senderId
      senderType
      content
      isRead
      createdAt
    }
  }
`);
